/**
 * Blockchain explorer address URLs for Stables wallet networks.
 * Keys match BaasStablesNetworkBadge / mapNetworkLabel labels.
 */
const ADDRESS_EXPLORERS = {
  Polygon: (address) => `https://polygonscan.com/address/${address}`,
  Ethereum: (address) => `https://etherscan.io/address/${address}`,
  Solana: (address) => `https://solscan.io/account/${address}`,
  Tron: (address) => `https://tronscan.org/#/address/${address}`,
};

const NETWORK_ALIASES = {
  polygon: "Polygon",
  matic: "Polygon",
  ethereum: "Ethereum",
  eth: "Ethereum",
  erc20: "Ethereum",
  solana: "Solana",
  sol: "Solana",
  tron: "Tron",
  trx: "Tron",
};

export const normalizeBaasStablesNetwork = (network) => {
  if (!network) return null;
  if (ADDRESS_EXPLORERS[network]) return network;
  return NETWORK_ALIASES[String(network).toLowerCase()] ?? null;
};

export const buildBaasStablesAddressExplorerUrl = (network, address) => {
  if (!address) return null;
  const resolved = normalizeBaasStablesNetwork(network);
  const builder = resolved ? ADDRESS_EXPLORERS[resolved] : null;
  return builder ? builder(address) : null;
};

export const truncateBaasStablesAddress = (address) => {
  if (!address || address.length < 12) return address ?? "—";
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
